module.exports = require('./_shared')('native-function-to-string', Function.toString);



// WEBPACK FOOTER //
// ./C:/Users/Pili/AppData/Roaming/npm/~/pink/~/core-js/modules/_function-to-string.js